
import type { TJobStatus } from "../JobStatus.js";
import { ReportBrief } from "../report/ReportBrief.js";
import type { TRiskRankWithNA } from "../risk/Risk.js";
import { contentIsSufficientForReportGeneration, type ContentStatus } from "./UseCaseChat.js";
export const ReportFreshnessStatuses = ["none", "current", "stale"] as const;
export type TReportFreshnessStatus = (typeof ReportFreshnessStatuses)[number];


export class UseCaseBrief {
   
    useCaseChatId: string = "";

    reports: ReportBrief[] = [];

    status: TJobStatus = "none";
    statusMessage: string = "";
    contentStatus: ContentStatus = "none";
    useCaseTitle: string = "";
    overallRiskRank: TRiskRankWithNA = "n/a";
    isStale: boolean = false;

    constructor(init?: Partial<UseCaseBrief>){
        Object.assign(this, init);
    }


    get jobIsActive(): boolean {
        return this.status === "queued" || this.status === "processing" || this.status === "paused";
    }

    get isSufficientForReportGeneration(): boolean {
        return contentIsSufficientForReportGeneration(this.contentStatus);
    }

}


